<template>
  <div id="page" class="page font--jakarta">
    <HeaderEmergeLayout />
    <slot />
    <FooterEmergeLayout />
  </div>
</template>

<style src="~/assets/css/color-scheme/emerge.scss" lang="scss"></style>
